import { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import { MyFetch } from "../../App";


const ClientDropdown = (props) => {
    const [list_Data, set_List_Data] = useState([])

    // useEffect(() => {
    //     fetch("http://127.0.0.1:5000/client/list", {
    //         method: "GET",
    //         mode: "cors",
    //         headers: { "Accept": "application/json", "Content-Type": "application/json" },
    //     }).then((res) => res.json())
    //         .then((data) => set_List_Data(data))
    // }, [])

    useEffect(() => {
        MyFetch("https://easytasks.in/client/list", {}, "GET")
          .then((res) => res.json())
          .then((data) => set_List_Data(data));
      }, [])

    const renderClient = (client, index) => {
        return (
            <option value={client.id}>{client.name}</option>
        )
    };

    return (
            <Form.Select aria-label="Default select example"
                name={props.name}
                value={props.value}
                onChange={props.onChange}
            >
                <option>Select client</option>
                {list_Data && list_Data.length > 0 ? list_Data.map(renderClient) : <></>}
            </Form.Select>
    )
}

export default ClientDropdown;